import React, { Component } from 'react';
import { geoPath } from 'd3-geo';
import clsx from 'clsx';

import { COUNTRY_ID_M49_TO_COMTRADE } from '../../constants';

import './_map-countries.scss';

const MIN_BOUND = 8;
const DOT_RADIUS = 4.5;

function parseM49Id(id) {
  const _id = parseInt(id, 10);
  return COUNTRY_ID_M49_TO_COMTRADE[_id] || _id;
}

export default function MapCountries({
  projection,
  transform,
  countries,
  countryPoints,
  filledCountries,
  renderDots,
  onHoverCountry,
  onClickCountry,
}) {
  const pathGenerator = geoPath().projection(projection);

  console.log('countryPoints', countryPoints);

  const handleHover = (id) => (event) => {
    if (event.type === 'mouseenter') {
      onHoverCountry(parseM49Id(id));
    } else {
      onHoverCountry(null);
    }
  };

  const handleClick = (id) => () => {
    onClickCountry(parseM49Id(id));
  };

  const countryPaths = [];
  const countryDots = [];

  countries.forEach(function (country) {
    let className;

    if (country.filled || filledCountries?.includes(country)) {
      className = 'filled';
    }

    const bounds = pathGenerator.bounds(country.geometry);
    const scale = transform?.scale || 1;
    const width = bounds[1][0] - bounds[0][0];
    const height = bounds[1][1] - bounds[0][1];
    const x = bounds[0][0] + width / 2;
    const y = bounds[0][1] + height / 2;

    const filled = className === 'filled' || country.colour;
    const interactive = (onClickCountry || onHoverCountry) && filled;
    const _handleHover = handleHover(country.id);
    const _handleClick = handleClick(country.id);

    if (renderDots && width * scale < MIN_BOUND && height * scale < MIN_BOUND && filled) {
      countryDots.push(
        <circle
          cx={x}
          cy={y}
          r={DOT_RADIUS / scale}
          className={clsx(className, interactive && 'interactive')}
          style={{ fill: country.colour ? country.colour : undefined }}
          onClick={onClickCountry && interactive ? _handleClick : undefined}
          onMouseEnter={onHoverCountry && interactive ? _handleHover : undefined}
          onMouseLeave={onHoverCountry && interactive ? _handleHover : undefined}
        />
      );
    }

    countryPaths.push(
      <path
        d={pathGenerator(country.geometry)}
        className={clsx(className, interactive && 'interactive')}
        style={{ fill: country.colour ? country.colour : undefined }}
        onClick={onClickCountry && interactive ? _handleClick : undefined}
        onMouseEnter={onHoverCountry && interactive ? _handleHover : undefined}
        onMouseLeave={onHoverCountry && interactive ? _handleHover : undefined}
      />
    );
  });

  (countryPoints || []).forEach(function (countryPoint) {
    if (!renderDots) {
      return;
    }

    if (!countryPoint.filled && !filledCountries?.includes(countryPoint) && !countryPoint.colour) {
      return;
    }

    const [x, y] = countryPoint.geometry.coordinates;
    const scale = transform?.scale || 1;

    pathGenerator.pointRadius(DOT_RADIUS / scale);

    const interactive = onClickCountry || onHoverCountry;
    const _handleHover = handleHover(countryPoint.id);
    const _handleClick = handleClick(countryPoint.id);

    countryPaths.push(
      <path
        d={pathGenerator(countryPoint.geometry)}
        className={clsx('filled', interactive && 'interactive')}
        style={{ fill: countryPoint.colour ? countryPoint.colour : undefined }}
        onClick={onClickCountry && interactive ? _handleClick : undefined}
        onMouseEnter={onHoverCountry && interactive ? _handleHover : undefined}
        onMouseLeave={onHoverCountry && interactive ? _handleHover : undefined}
      />
    );
  });

  return (
    <g className="map__countries">
      {countryPaths}
      {countryDots}
    </g>
  );
}
